import '../../Styles/Aboutus.css'
import Qoute_icon from '../../Assets/Icons/qoute.svg'
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Container,
  Box,
} from '@mui/material'
import HCarosel from '../../Component/Carosel/Header_Carosel'
import KakaPhoto from '../../Assets/Images/Kaka-venkataswamy-2-768x538 1.png'

const employee_Data = [
  {
    employe_name: 'Dr.G. Vivek Venkatswamy',
    designation: 'CHAIRMAN',
    description: 'MLA (CHENNURU)',
    image_path:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/dr-vivek.jpg',
  },
  {
    employe_name: 'Dr.G. Vinod',
    designation: 'SECRETARY',
    description: 'MLA (BELLAMPALLI)',
    image_path:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/G-Vinod-Kumar.jpg',
  },
  {
    employe_name: 'Dr.G. Saroja Vivekanand',
    designation: 'CORRESPONDENT',
    description: 'Managing Director – Visaka Industries',
    image_path:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/g-saroja.jpg',
  },
  {
    employe_name: 'G. RAMA',
    designation: 'JOINT SECRETARY',
    description: 'DBRAEI Joint secretary',
    image_path:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/g-rama.jpg',
  },
  {
    employe_name: 'PV Ramana Kumar',
    designation: 'JOINT SECRETARY',
    description: 'DBRAEI Joint secretary',
    image_path:
      'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/ramana-kumar.jpg',
  },
]

const About_us = () => {
  return (
    <Box sx={{ backgroundColor: '#DFE5F0', py: 3 }}>
      <Container maxWidth="lg">
        {/* Header Carousel */}
        <HCarosel />

        {/* About Heading */}
        <Box
          sx={{
            textAlign: 'center',
            mb: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: { xs: 1, sm: 2, md: 3 }, // Adjust spacing for different screen sizes
            flexWrap: 'wrap', // Stacks elements when screen is small
            p: { xs: 2, sm: 3 },
          }}
        >
          <img
            src={Qoute_icon}
            alt="Quote Icon"
            loading="lazy"
            placeholder="blur"
            style={{ height: '40px', minWidth: '40px' }}
          />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem' }, // Responsive text size
            }}
          >
            Education is the key to a better future.
          </Typography>
          <img
            src={Qoute_icon}
            alt="Quote Icon"
            loading="lazy"
            placeholder="blur"
            style={{
              height: '40px',
              minWidth: '40px',
              transform: 'scaleX(-1)',
            }}
          />
        </Box>

        {/* Founder Section */}
        <Grid container spacing={4} sx={{ mb: 6, alignItems: 'center' }}>
          {/* Founder Image Section */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: 2,
                textAlign: 'center',
                backgroundColor: '#f5f5f5',
              }}
            >
              <img
                src={KakaPhoto}
                alt="Late Sri G Venkat Swamy"
                loading="lazy"
                placeholder="blur"
                style={{
                  width: '100%',
                  maxWidth: '350px',
                  borderRadius: '10px',
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                }}
              />
              <Typography variant="h5" fontWeight="bold" mt={2} color="primary">
                Sri G Venkat Swamy
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ color: '#6D4C41', fontStyle: 'italic' }}
              >
                Founder & Chairman
              </Typography>
            </Card>
          </Grid>

          {/* Founder Biography Section */}
          <Grid item xs={12} md={7}>
            <Box sx={{ pl: { md: 3 }, textAlign: 'justify' }}>
              <Typography
                variant="h4"
                fontWeight="bold"
                mb={2}
                sx={{ color: '#e79b82' }}
              >
                About Founder
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                Born on October 5, 1929, the late Sri G Venkat Swamy, Founder
                and Chairman of Dr. B. R. Ambedkar Educational Institutions, was
                the visionary behind the establishment of this esteemed
                institution. With an analytical mind, infinite capacity for
                work, and a deep commitment to human welfare, he also served as
                a veteran Congress leader and Ex-Union minister of the
                Government of India.
                <br />
                <br />
                Popularly known as ‘Kaka’, his political career began in 1950
                and spanned over five decades. As a four-time Member of
                Parliament, he served his last term in 2004. Kaka tirelessly
                worked to improve the lives of the weaker sections of society
                and played a key role as the General Secretary of the National
                Huts Union in Hyderabad, providing permanent accommodation for
                75,000 hut dwellers.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Started In 1973 Section */}
        <Grid container spacing={3} sx={{ mb: 4, bgcolor: 'lightblue', p: 3 }}>
          <Grid item xs={12} md={6}>
            <img
              src="https://dbraeiassetmanagement.blob.core.windows.net/dbralc/prod/homepage slider/ArialView.jpeg"
              alt="College View"
              loading="lazy"
              placeholder="blur"
              style={{ width: '100%', borderRadius: '8px' }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" mb={2}>
              Started In 1973
            </Typography>
            <Typography variant="body1">
              Dr. B. R. Ambedkar Law College in Hyderabad is a renowned
              institution that has been empowering students with legal education
              for decades. With a focus on social justice and equality, the
              college has produced numerous accomplished legal professionals who
              have made a signiﬁcant impact on society. This presentation will
              delve into the rich history and contributions of Dr. B. R.
              Ambedkar Law College. Dr B R Ambedkar Law College, an integral
              part of Dr B R Ambedkar Educational Institutions was established
              in the year 1991, by late G. Venkataswamy Garu, the then Member of
              Parliament and Deputy Floor leader during 2000-2001. He was also a
              visionary for a progressive society. It is a moment of pride for
              our college for having completed glorious 32 years of
              establishment. Imparting legal education was the most cherished
              dream of our founder Chairman Late.Sri G. Venkat Swamy Garu. Since
              its establishment in 1991, Dr. B R Ambedkar Law College has been
              successful in producing legal luminaries, bureaucrats & judges.
            </Typography>
          </Grid>
        </Grid>

        {/* Campus Section */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h5" mb={2}>
            Campus
          </Typography>
          <Typography variant="body1">
            The campus is spread across 3 acres landscape known for its
            salubrious climate and presents a congenial atmosphere to pursue
            higher studies. Our vibrant infrastructure is a facilitator for the
            effective delivery of our curriculum. Apart from the common central
            facilities, the colleges have well-equipped laboratories, lecture
            halls and seminar halls.
          </Typography>
        </Box>

        {/* Meet the Founders Section */}
        <Box>
          <Typography variant="h4" textAlign="center" mb={3}>
            Meet the Founders
          </Typography>
          <Grid container spacing={3}>
            {employee_Data.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card sx={{ height: '100%' }}>
                  <CardMedia
                    component="img"
                    height="300"
                    image={item.image_path}
                    alt={item.employe_name}
                    loading="lazy"
                    placeholder="blur"
                  />
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {item.employe_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="div"
                    >
                      {item.designation}
                      <br />
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}

export default About_us
